var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"legend"},[_c('div',{staticClass:"legend-title"},[_vm._v(_vm._s(_vm.title))]),_vm._l((_vm.entries),function(l,i){return _c('LegendEntry',{key:i,staticClass:"legend-item",attrs:{"name":l.name,"color":l.color}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }